const statusColors = {
    '5' : 'bg-yellow-100 text-yellow-800',
    '6': 'bg-blue-100 text-blue-800',
    '7': 'bg-purple-100 text-purple-800',
    '8': 'bg-green-100 text-green-800',
    '9': 'bg-red-100 text-red-800',
  };

  module.exports = statusColors;